export const isBlankName = (value?: string | null) =>
  !value || value.trim() === ''

const chosenName = (entered?: string | null, profile?: string | null) => {
  const typed = entered?.trim()
  if (typed) {
    return typed
  }
  const existing = profile?.trim()
  return existing || undefined
}

/** Name to store on the profile before cards are created. The typed name wins. */
export const legalNameForProfileUpdate = (
  profileFirstName?: string | null,
  profileLastName?: string | null,
  enteredFirstName?: string | null,
  enteredLastName?: string | null
) => {
  const firstName = chosenName(enteredFirstName, profileFirstName)
  const lastName = chosenName(enteredLastName, profileLastName)
  return {
    ...(firstName ? { firstName } : {}),
    ...(lastName ? { lastName } : {}),
  }
}

export const EmployeeOnboardingContent = {
  extraInfo: {
    leftHeader: 'We need some more info to finish setting up your account.',
  },
  acceptTerms: {
    leftHeader:
      'Please Accept the Terms and Conditions for the Fleet Mobility Card',
  },
}
